import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IServiceToolbarBase, PagedBaseResponse } from 'rte-library';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Provider } from './provider.model';
import { appendHttpParams } from '../../helpers/http.helper';

@Injectable({
  providedIn: 'root'
})
export class ProviderService implements IServiceToolbarBase<Provider> {

  constructor(private http: HttpClient) {
  }

  clear(objectCurrent: Provider) {
    if (objectCurrent != null) {
      objectCurrent.Name = null;
      objectCurrent.Revision = null;
      objectCurrent.Id = null;
      objectCurrent.ProviderType = null;
      objectCurrent.Description = null;
      objectCurrent.ConnectionString = null;
    }
  }

  save(objectCurrent: Provider) {

    if ( objectCurrent.Id <= 0  || objectCurrent.Id == null) {
      delete objectCurrent.Id;
      delete objectCurrent.Revision;
      return this.http.post(environment.apiUrl + 'api/providers', objectCurrent);
    } else {
      objectCurrent.Revision = !objectCurrent.Revision ? 1 : objectCurrent.Revision;
      return this.http.put(environment.apiUrl + 'api/providers', objectCurrent);
    }
  }

  delete(objectCurrent: Provider): Observable<boolean> {
    const params = new HttpParams()
                    .set('id', objectCurrent.Id.toString());

    return this.http.delete<boolean>(environment.apiUrl + 'api/providers', {params});
  }

  get(objectCurrent: Provider, page: number, pageSize: number): Observable<PagedBaseResponse<Provider>> {
    page++;
    let params = new HttpParams()
                    .set('Page',page.toString())
                    .set('AmountByPage', pageSize.toString());

    if (objectCurrent) {
      params = appendHttpParams('Id', objectCurrent.Id, params);
      params = appendHttpParams('ProviderType', objectCurrent.ProviderType != null ? objectCurrent.ProviderType.toString() : objectCurrent.ProviderType, params);
      params = appendHttpParams('ConnecionString', objectCurrent.ConnectionString, params);
      params = appendHttpParams('Description', objectCurrent.Description, params);
      params = appendHttpParams('Name', objectCurrent.Name, params);
    }
    return this.http.get<PagedBaseResponse<Provider>>(environment.apiUrl + 'api/providers/search', {params});
  }

  getByAmountPage(page: number, amountByPage: number): Observable<PagedBaseResponse<Provider>> {
    page++;
    const params = new HttpParams()
                    .set('Page', page.toString())
                    .set('AmountByPage', amountByPage.toString());

    return this.http.get<PagedBaseResponse<Provider>>(environment.apiUrl + 'api/providers/search', {params});
  }

  getAll(): Observable<Provider[]> {
    return this.http.get<Provider[]>(environment.apiUrl + 'api/providers');
  }
}
